module.exports = __webpack_public_path__ + "static/img/contract_step_4.02f34b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract_step_4.png
// module id = K83+
// module chunks = 1